import { useEffect, useState } from "react";

/**
 * Tracks whether the page is actively scrolling.
 * - Toggles a `is-scrolling` class on <body> so CSS can blur cheaply without React re-renders.
 * - Returns a debounced boolean so media can pause while scrolling and resume once settled.
 */
export function useScrollIdle(idleDelay = 160) {
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    let timeout = 0;
    let active = false;

    const onScroll = () => {
      if (!active) {
        active = true;
        document.body.classList.add("is-scrolling");
        setScrolling(true);
      }
      window.clearTimeout(timeout);
      timeout = window.setTimeout(() => {
        active = false;
        document.body.classList.remove("is-scrolling");
        setScrolling(false);
      }, idleDelay);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.clearTimeout(timeout);
      document.body.classList.remove("is-scrolling");
    };
  }, [idleDelay]);

  return scrolling;
}
